module.exports = __webpack_public_path__ + "static/media/Robotomedium.6422eac7.woff";